import React, { useState, Fragment, Component } from 'react'
import TeamBloc from "../Blocs/TeamBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from "../../../../../services/adapters/master/penialian360Service"
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import moment from "moment"
import { Redirect } from "react-router-dom"
import 'moment/locale/id'
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner,
    Label
} from "reactstrap"

class IndexComponent extends Component 
{
    teamBloc = new TeamBloc();

    source
    historyTable = 'periode360Active'
    defaultOrder = 'ms360_period_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
 

    constructor(props) {
        super(props)
        this.state = {
            loadingTitle: "Mengirim data...",
            validateMessage: "",
            messageFailed: "Data gagal disimpan",
            periodUuid: "",
            inactiveUuid: "",
            dataForm: {},
            obj: null,
            modalShow: false,
            modalToggle: false,
            tooltip: false,  
            detailUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.teamBloc.fetchPeriod(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    handlerOnSubmit = async (e, values) => {
        e.preventDefault();
        var userdata = JSON.parse(localStorage.getItem("userdata"));
        var create_uuid = userdata.employee_uuid;
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true,
        });
    };

     confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

   
    componentDidMount() {

        this.setTokenAPI()

        this.teamBloc.timkerjaPeriodChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

       

        this.teamBloc.timkerjaPeriodCreateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        messageFailed: '',
                        failed: false,
                        loadingTitle: "Mengirim data...",
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        messageFailed: '',
                        failed: false,
                        loadingTitle: "Mengirim data...",
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const valid = response.valid
                    if(valid){

                        setTimeout(() => { 

                            this.setState({
                                messageFailed: '',
                                loading: false,
                                success: true,
                                modalShow: false,
                                modalToggle: false,
                                inactiveUuid: '',
                                obj: null,
                                validateMessage: null,
                                loadingTitle: "Mengirim data...",
                            });
                            this.setTokenAPI()
                            
                        }, 500)

                    }else{
                        this.setState({
                           loading: false,
                           validateMessage: response?.message,
                           loadingTitle: "Mengirim data...",
                        });
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({
                        success: false,
                        loading: false,
                        failed: true,
                        messageFailed: response?.message,
                        loadingTitle: "Mengirim data...",
                    });
                    break
                default:
                    break
            }
        })

        this.teamBloc.timkerjaPeriodDeleteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        modalShow: false,
                        modalToggle: false,
                        inactiveUuid: '',
                        obj: null
                    });
                    this.setTokenAPI()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    
    }

    columns = [
        {
            key: "ms360_period_date_start",
            text: "PERIODE AWAL",
            className: "ms360_period_date_start",
            sortable: true,
            cell: record => {
                return (record.ms360_period_date_start != null) ? moment(record.ms360_period_date_start).format('DD MMMM YYYY') : '-';
            }
        },
        {
            key: "ms360_period_date_end",
            text: "PERIODE AKHIR",
            className: "ms360_period_date_end",
            sortable: true,
            cell: record => {
                return (record.ms360_period_date_end != null) ? moment(record.ms360_period_date_end).format('DD MMMM YYYY') : '-';
            }
        },
        {
            key: "total_team",
            text: "TOTAL TIM",
            className: "total_team",
            sortable: false,
            align: 'center',
            cell: record => {
                const total = parseInt(record.total_team);
                return (<span className="badge bg-success">{total}</span>)
            }
        },
        {
            key: "ms360_period_id",
            text: "STATUS",
            className: "ms360_period_id",
            sortable: false,
            align: 'center',
            cell: record => {
                const startDate = record.ms360_period_date_start;
                const endDate = record.ms360_period_date_end;
                const today = moment().startOf('day');
                const start = moment(startDate).startOf('day');
                const end = moment(endDate).endOf('day');
                if (today.isBefore(start)) {
                    return (<span className="badge bg-warning">{'Pending'}</span>)
                }else if (today.isAfter(end)) {
                    return (<span className="badge bg-danger">{'Berakhir'}</span>)
                }else{
                    return (<span className="badge bg-success">{'Berlangsung'}</span>)
                }
            }
        },
        {
            key: "action",
            text: "AKSI",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.ms360_period_uuid;
                return (
                    <Fragment>
                        <span>
                            <button 
                                className="btn btn-success btn-sm" 
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.ms360_period_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-search"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Lihat Detail</Tooltip>
                        </span>
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"update-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        modalShow: true,
                                        obj: record,
                                        updateUuid: thisId
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-pen"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["update" + thisId] : !this.state["update" + thisId]
                                    })
                                }}
                            >Perbaharui</Tooltip>
                        </span>
                        <span>
                            <button 
                                className="btn btn-danger btn-sm" 
                                id={"delete-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        inactiveUuid: record.ms360_period_uuid,
                                        confirm: true
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                <i className="uil-trash-alt"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["delete" + thisId] : !this.state["delete" + thisId]
                                    })
                                }}
                            >Hapus</Tooltip>
                        </span>
                    </Fragment>
                )
            }
        }
    ]

    //  submitData = async () => {

    //     if(this.state.inactiveUuid !== undefined && this.state.inactiveUuid !== null && this.state.inactiveUuid !== ''){
    //         await this.teamBloc.fetchPeriodDelete({ uuid: this.state.inactiveUuid })
    //     }else{
            
    //         document.querySelector(".sweet-alert h2").textContent = `20.00 %`;
    //         const dataForm = this.state.dataForm;
    //         const formData = new FormData();

    //         if(this.state.obj !== undefined && this.state.obj !== null){
    //             formData.append("uuid", this.state.obj.ms360_period_uuid ?? "");
    //         }

    //         formData.append("date_start", dataForm?.ms360_period_date_start)
    //         formData.append("date_end", dataForm?.ms360_period_date_end)
    //         await this.teamBloc.fetchPeriodCreate(formData)
    //         document.querySelector(".sweet-alert h2").textContent = `99.00 %`;
    //     }

       
    // };

    submitData = async () => {

        if (
            this.state.inactiveUuid !== undefined &&
            this.state.inactiveUuid !== null &&
            this.state.inactiveUuid !== ''
        ) {
            await this.teamBloc.fetchPeriodDelete({
                uuid: this.state.inactiveUuid
            });

            return;
        }

        const setProgress = (value) => {
            console.log(value)
            this.setState({
                loadingTitle: `${value} % Mengirim Data ...`
            })
        };

        setProgress(20);

        // Allow browser to actually paint 20%
        await new Promise(resolve => requestAnimationFrame(resolve));

        const dataForm = this.state.dataForm;
        const formData = new FormData();

        if (this.state.obj !== undefined && this.state.obj !== null) {
            formData.append(
                "uuid",
                this.state.obj.ms360_period_uuid ?? ""
            );
        }

        formData.append(
            "date_start",
            dataForm?.ms360_period_date_start
        );

        formData.append(
            "date_end",
            dataForm?.ms360_period_date_end
        );

        // Fake progress while request is running
        let progress = 20;

        const interval = setInterval(() => {
            if (progress < 95) {
                progress += 1;
                setProgress(progress);
            }
        }, 200);

        try {

            await this.teamBloc.fetchPeriodCreate(formData);

            clearInterval(interval);

            setProgress(99);

            await new Promise(resolve => setTimeout(resolve, 300));

            setProgress(100);

        } catch (error) {

            clearInterval(interval);

            console.error(error);

            throw error;
        }
    };


    componentWillUnmount(){
        this.teamBloc.timkerjaPeriodChannel.unsubscribe()
        this.teamBloc.timkerjaPeriodCreateChannel.unsubscribe()
        this.teamBloc.timkerjaPeriodDeleteChannel.unsubscribe()
    }

    render(){
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <Card className="">
                                <CardBody>
                                     <div className="float-end">
                                        <Button onClick={() => { this.setState({ modalShow:true, obj:null }) }} color="primary">
                                            <i className="uil-plus me-2"></i>Tambah Data
                                        </Button>
                                    </div>
                                    <CardTitle>Daftar Periode Penialian 360</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Kelola Periode Penialian 360
                                    </CardSubtitle>
                                    <hr />
                                    <MKIDatatable
                                        className={this.configDatatable.tableClass}
                                        config={this.configDatatable}
                                        records={this.state.rows}
                                        columns={this.columns}
                                        dynamic={true}
                                        minWidth={1000}
                                        total_record={this.state.totalRow}
                                        initial={this.state.filter}
                                        onChange={(filter) => {
                                            this.setState({
                                                loadingTable: true,
                                                filter: filter
                                            }, function () {
                                                this.setTokenAPI()
                                            });
                                        }}
                                        loading={this.state.loadingTable}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                   <Modal isOpen={this.state.modalShow} size="lg" toggle={this.state.modalToggle}>
                    <AvForm className="needs-validation" onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}>
                        <ModalHeader toggle={this.state.modalToggle}>
                            { this.state.obj !== undefined && this.state.obj !== null ? <>
                                Edit Periode Penialaian 360 
                            </> : <>
                                Tambah Periode Penialaian 360
                            </> }
                        </ModalHeader>
                        <ModalBody>
                            { this.state.validateMessage  ? <>
                                <div class="alert alert-danger">
                                    <strong>⚠️ Validasi Gagal</strong>
                                    <p>{this.state.validateMessage}</p>
                                </div>                
                            </> : <></> }
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Periode Awal <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <AvField
                                        name="ms360_period_date_start"
                                        placeholder="Periode Awal..."
                                        type="date"
                                        errorMessage="Masukkan Periode Awal"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        id="ms360_period_date_start"
                                        value={this.state.obj?.ms360_period_date_start ?? ""}
                                    />     
                                </Col>
                            </Row>       
                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                   Tanggal Akhir <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <AvField
                                        name="ms360_period_date_end"
                                        placeholder="Periode Awal..."
                                        type="date"
                                        errorMessage="Masukkan Periode Akhir"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                        id="ms360_period_date_end"
                                        value={this.state.obj?.ms360_period_date_end ?? ""}
                                    />     
                                </Col>
                            </Row>       
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => { this.setState({ modalShow: false }) }}>
                                Batal
                            </Button>{" "}
                            <Button color="primary" type="submit" >
                                { this.state.obj !== undefined && this.state.obj !== null ? <>
                                    Update
                                </> : <>
                                    Simpan
                                </> }
                            </Button>           
                        </ModalFooter>
                    </AvForm>                 
                    </Modal>
                    { this.state.detailUuid !== null ?
                        <Redirect to={"/master/timkerja360.html?section=team&uuid=" + this.state.detailUuid}/>
                    : null }
                     <ConfirmAlert
                        confirmTitle="Konfirmasi!"
                        confirmInfo={this.state.inactiveUuid ? 'Apakah anda yakin hapus data' : "Apakah anda yakin data tersebut sudah benar?"}
                        loadingTitle={this.state.loadingTitle}
                        loadingInfo="Tunggu beberapa saat"
                        successTitle="Berhasil!"
                        successInfo={'Data berhasil diperbaharui'}
                        failedTitle="Gagal!"
                        failedInfo={this.state.messageFailed}
                        showConfirm={this.state.confirm}
                        showLoading={this.state.loading}
                        showSuccess={this.state.success}
                        showFailed={this.state.failed}
                        response={this.confirmResponse}
                    />
            </Fragment>
        )
    }

}

export default IndexComponent